// src/data/text.ts

export const galleryFolders = {
    "Warszawa Syta": {
        link: "warszawa-syta",
        title: {
            pl: "Warszawa Syta",
            en: "Warszawa Syta"
        },
        descriptionTitle: {
            pl: "Warszawa Syta",
            en: "Warszawa Syta"
        },
        description: {
            pl: "",
            en: ""
        },
        imageCount: 38,
        video: false
    },

    "budowa domu": {
        link: "budowa-domu",
        title: {
            pl: "budowa domu",
            en: "house construction"
        },
        descriptionTitle: {
            pl: "Budowa domu jednorodzinnego w Poznaniu",
            en: "Single-family house construction in Poznań"
        },
        description: {
            pl: "",
            en: ""
        },
        imageCount: 20,
        video: false
    },

    "Poznań ul. Solna": {
        title: {
            pl: "Poznań ul. Solna",
            en: "Poznań – Solna Street"
        },
        link: "poznan-ul-solna",
        descriptionTitle: {
            pl: "Mieszkanie wykończone według indywidualnego projektu – ul. Solna",
            en: "Apartment finished according to a custom design – Solna Street"
        },
        imageCount: 22,
        description: {
            pl: `
      Realizacja mieszkania w inwestycji przy ul. <strong>Solnej</strong> w Poznaniu, zrealizowana we współpracy z deweloperem 
      <strong><a href="https://okre.pl" target="_blank" class="underline hover:text-gray-300 transition">OKRE Development</a></strong>.
      <br><br>
      Projekt został przygotowany bez udziału biura projektowego – za koncepcję odpowiadał bezpośrednio właściciel mieszkania. 
      Naszym zadaniem było dokładne odwzorowanie jego wizji, z dbałością o detale i jakość wykończenia.
      <br><br>
      <strong>Zakres prac:</strong><br>
      – modyfikacje instalacji pod kątem funkcjonalności projektu<br>
      – zabudowy i przedścianki według indywidualnych wymiarów<br>
      – prace glazurnicze i wykończeniowe<br>
      – kompleksowe przygotowanie wnętrza pod umeblowanie i montaż oświetlenia
    `,
            en: `
      Apartment completed in the <strong>Solna</strong> Street development in Poznań, carried out in cooperation with 
      <strong><a href="https://okre.pl" target="_blank" class="underline hover:text-gray-300 transition">OKRE Development</a></strong>.
      <br><br>
      The project was created without the involvement of a design studio – the concept was developed directly by the apartment owner. 
      Our task was to reproduce the vision with attention to detail and quality of finishing.
      <br><br>
      <strong>Scope of work:</strong><br>
      – modifications to installations based on functional requirements<br>
      – custom partition walls and drywall structures<br>
      – tiling and finishing work<br>
      – comprehensive interior preparation for furniture and lighting installation
    `
        },
        video: false
    },

    "Fama Jeżyce": {
        title: {
            pl: "Fama Jeżyce",
            en: "Fama Jeżyce"
        },
        link: "fama-jezyce",
        descriptionTitle: {
            pl: "Mieszkanie deweloperskie pod projekt – realizacja we współpracy z OYKA Studio",
            en: "Developer apartment finished according to the project – completed in cooperation with OYKA Studio"
        },
        imageCount: 11,
        description: {
            pl: `
      Kompleksowe wykończenie mieszkania deweloperskiego w inwestycji Fama Jeżyce, realizowane we współpracy z 
      <a href="https://oyka.pl" target="_blank" class="underline hover:text-gray-300 transition">OYKA Studio</a>.
      <br><br>
      <strong>Zakres prac:</strong><br>
      – usunięcie ścian działowych<br>
      – zmiany w instalacji wodno-kanalizacyjnej<br>
      – prace elektryczne<br>
      – szpachlowanie<br>
      – montaż przedścianek<br>
      – prace glazurnicze<br>
      – pełne przygotowanie wnętrza pod wykończenie końcowe
    `,
            en: `
      Comprehensive finishing of a developer apartment in the Fama Jeżyce investment, carried out in cooperation with 
      <a href="https://oyka.pl" target="_blank" class="underline hover:text-gray-300 transition">OYKA Studio</a>.
      <br><br>
      <strong>Scope of work:</strong><br>
      – removal of partition walls<br>
      – plumbing and drainage modifications<br>
      – electrical work<br>
      – plastering<br>
      – installation of wall linings<br>
      – tiling<br>
      – full preparation of the interior for final finishing
    `
        },
        video: false
    },

    "Wrocław Planty Racławickie": {
        title: {
            pl: "Wrocław Planty Racławickie",
            en: "Wrocław – Planty Racławickie"
        },
        link: "wroclaw-planty-raclawickie",
        descriptionTitle: {
            pl: "Mieszkanie wykończone zgodnie z planem inwestora – Wrocław, Planty Racławickie",
            en: "Apartment finished according to investor’s plan – Wrocław, Planty Racławickie"
        },
        imageCount: 23,
        description: {
            pl: `
      Realizacja mieszkania zlokalizowanego w nowoczesnym kompleksie <strong>Planty Racławickie</strong> we Wrocławiu. 
      Projekt został przygotowany w całości przez inwestora – bez udziału architekta wnętrz.
      <br><br>
      Naszym zadaniem było odwzorowanie założeń i układu funkcjonalnego zgodnie z przygotowanym planem, 
      z pełnym wsparciem technicznym na każdym etapie prac.
      <br><br>
      <strong>Zakres prac:</strong><br>
      – układanie instalacji wodno-kanalizacyjnej i elektrycznej<br>
      – zabudowy z płyt g-k oraz przygotowanie ścian<br>
      – montaż podłóg, glazury, sanitariatów i armatury<br>
      – prace malarskie i końcowe przygotowanie mieszkania pod montaż mebli
    `,
            en: `
      Apartment located in the modern <strong>Planty Racławickie</strong> complex in Wrocław. 
      The project was fully prepared by the investor – without the involvement of an interior architect.
      <br><br>
      Our task was to implement the assumptions and functional layout in accordance with the plan, 
      providing full technical support at every stage of the work.
      <br><br>
      <strong>Scope of work:</strong><br>
      – plumbing and electrical installations<br>
      – drywall structures and wall preparation<br>
      – installation of floors, tiles, sanitary ware and fittings<br>
      – painting and final preparation of the apartment for furniture installation
    `
        },
        video: false
    },

    "ul. Sowia Poznań": {
        title: {
            pl: "ul. Sowia Poznań",
            en: "Sowia Street, Poznań"
        },
        link: "ul-sowia-poznan",
        descriptionTitle: {
            pl: "ul. Sowia Poznań",
            en: "Sowia Street, Poznań"
        },
        description: {
            pl: "",
            en: ""
        },
        imageCount: 15,
        video: false
    },

    "Wrocław Ul. Rycerska": {
        title: {
            pl: "Wrocław Ul. Rycerska",
            en: "Rycerska Street – Wrocław"
        },
        link: "wroclaw-ul-rycerska",
        descriptionTitle: {
            pl: "Wrocław Ul. Rycerska",
            en: "Rycerska Street – Wrocław"
        },
        description: {
            pl: "",
            en: ""
        },
        imageCount: 17,
        video: false
    },

    "Apartament ul. Ceglana": {
        title: {
            pl: "Apartament ul. Ceglana",
            en: "Apartment – Ceglana Street"
        },
        link: "apartament-ul-ceglana",
        descriptionTitle: {
            pl: "Apartament ul. Ceglana",
            en: "Apartment – Ceglana Street"
        },
        description: {
            pl: "",
            en: ""
        },
        imageCount: 28,
        video: false
    },

    "Lee Wrangler Posnania": {
        title: {
            pl: "Lee Wrangler Posnania",
            en: "Lee Wrangler Posnania"
        },
        link: "lee-wrangler-posnania",
        descriptionTitle: {
            pl: "Lee Wrangler Posnania",
            en: "Lee Wrangler Posnania"
        },
        description: {
            pl: "",
            en: ""
        },
        imageCount: 10,
        video: false
    },

    "Lokal Blikle Poznań": {
        title: {
            pl: "Lokal Blikle Poznań",
            en: "Blikle Premises Poznań"
        },
        link: "lokal-blikle-poznan",
        descriptionTitle: {
            pl: "Lokal Blikle Poznań",
            en: "Blikle Premises Poznań"
        },
        description: {
            pl: "",
            en: ""
        },
        imageCount: 11,
        video: false
    },

    "Osiedle Jagiellońskie": {
        title: {
            pl: "Osiedle Jagiellońskie",
            en: "Jagiellońskie Estate"
        },
        link: "osiedle-jagiellonskie",
        descriptionTitle: {
            pl: "Osiedle Jagiellońskie",
            en: "Jagiellońskie Estate"
        },
        description: {
            pl: "",
            en: ""
        },
        imageCount: 19,
        video: false
    },

    "Niegolewskich Poznań": {
        title: {
            pl: "Niegolewskich Poznań",
            en: "Niegolewskich Poznań"
        },
        link: "niegolewskich-poznan",
        descriptionTitle: {
            pl: "Niegolewskich Poznań",
            en: "Niegolewskich Poznań"
        },
        description: {
            pl: "",
            en: ""
        },
        imageCount: 11,
        video: false
    },


    "Poznań ul. Bułgarska": {
        title: {
            pl: "Poznań ul. Bułgarska",
            en: "Poznań – Bułgarska Street"
        },
        link: "poznan-ul-bulgarska",
        descriptionTitle: {
            pl: "Poznań ul. Bułgarska",
            en: "Poznań – Bułgarska Street"
        },
        description: {
            pl: "",
            en: ""
        },
        imageCount: 19,
        video: false
    },

    "Midori Wrocław": {
        title: {
            pl: "Midori Wrocław",
            en: "Midori Wrocław"
        },
        link: "midori-wroclaw",
        descriptionTitle: {
            pl: "Midori Wrocław",
            en: "Midori Wrocław"
        },
        description: {
            pl: "",
            en: ""
        },
        imageCount: 1,
        video: false
    },

    "Strzeszyn Poznań": {
        title: {
            pl: "Strzeszyn Poznań",
            en: "Strzeszyn Poznań"
        },
        link: "strzeszyn-poznan",
        descriptionTitle: {
            pl: "Strzeszyn Poznań",
            en: "Strzeszyn Poznań"
        },
        description: {
            pl: "",
            en: ""
        },
        imageCount: 1,
        video: false
    },

    "Okolice Buku rewitalizacja kostki": {
        title: {
            pl: "Okolice Buku rewitalizacja kostki",
            en: "Buk area paving revitalization"
        },
        link: "okolice-buku-rewitalizacja-kostki",
        descriptionTitle: {
            pl: "Okolice Buku rewitalizacja kostki",
            en: "Buk area paving revitalization"
        },
        description: {
            pl: "",
            en: ""
        },
        imageCount: 1,
        video: false
    },

    "Osiedle Blisko Gdańsk": {
        title: {
            pl: "Osiedle Blisko Gdańsk",
            en: "Blisko Estate – Gdańsk"
        },
        link: "osiedle-blisko-gdansk",
        descriptionTitle: {
            pl: "Osiedle Blisko Gdańsk",
            en: "Blisko Estate – Gdańsk"
        },
        description: {
            pl: "",
            en: ""
        },
        imageCount: 1,
        video: false
    },

    "Wilda Story Poznań": {
        title: {
            pl: "Wilda Story Poznań",
            en: "Wilda Story – Poznań"
        },
        link: "wildastory-poznan",
        descriptionTitle: {
            pl: "Wilda Story Poznań",
            en: "Wilda Story – Poznań"
        },
        description: {
            pl: "",
            en: ""
        },
        imageCount: 1,
        video: false
    },

    "Lune de Malta Poznań": {
        title: {
            pl: "Lune de Malta Poznań",
            en: "Lune de Malta Poznań"
        },
        link: "lune-de-malta-poznan",
        descriptionTitle: {
            pl: "Lune de Malta Poznań",
            en: "Lune de Malta Poznań"
        },
        description: {
            pl: "",
            en: ""
        },
        imageCount: 1,
        video: false
    },

    "Bergera Poznań": {
        title: {
            pl: "Bergera Poznań",
            en: "Bergera Poznań"
        },
        link: "bergera-poznan",
        descriptionTitle: {
            pl: "Mieszkanie deweloperskie – kompleksowa realizacja wykończenia wnętrz",
            en: "Developer apartment – complete interior finishing"
        },
        description: {
            pl: `
      Kompleksowa realizacja wykończenia mieszkania deweloperskiego zlokalizowanego przy ul. <strong>Bergera</strong> w Poznaniu.
      <br><br>
      W projekcie nie brało udziału żadne biuro projektowe – wszystkie prace zostały wykonane bezpośrednio w oparciu o ustalenia z klientem. 
      Od surowych ścian po gotowe wnętrze – zadbaliśmy o każdy etap prac.
      <br><br>
      <strong>Zakres prac:</strong><br>
      – przygotowanie i zabezpieczenie mieszkania<br>
      – zmiany w instalacji wodno-kanalizacyjnej<br>
      – instalacje sanitarne i elektryczne<br>
      – montaż stelaży, zabudów oraz przedścianek<br>
      – wyrównanie i przygotowanie posadzek<br>
      – prace tynkarskie, szpachlowanie i gruntowanie<br>
      – prace glazurnicze<br>
      – pełne przygotowanie wnętrza pod dalsze umeblowanie
    `,
            en: `
      Comprehensive interior finishing of a developer apartment located on <strong>Bergera</strong> Street in Poznań.
      <br><br>
      No design office was involved – all works were carried out directly based on arrangements with the client. 
      From raw walls to a fully finished interior – we took care of every stage.
      <br><br>
      <strong>Scope of work:</strong><br>
      – preparation and protection of the apartment<br>
      – plumbing and drainage modifications<br>
      – sanitary and electrical installations<br>
      – installation of frames, built-ins and partition linings<br>
      – floor leveling and preparation<br>
      – plastering, smoothing and priming<br>
      – tiling<br>
      – complete preparation of the interior for further furnishing
    `
        },
        imageCount: 11,
        video: false
    },

    "Os. Kalinowe Rokietnica": {
        title: {
            pl: "Os. Kalinowe Rokietnica",
            en: "Kalinowe Estate – Rokietnica"
        },
        link: "os-kalinowe-rokietnica",
        descriptionTitle: {
            pl: "Os. Kalinowe Rokietnica",
            en: "Kalinowe Estate – Rokietnica"
        },
        description: {
            pl: "",
            en: ""
        },
        imageCount: 1,
        video: false
    },

    "ul. Olszynowa Rabowice": {
        title: {
            pl: "ul. Olszynowa Rabowice",
            en: "Olszynowa Street – Rabowice"
        },
        link: "ul-olszynowa-rabowice",
        descriptionTitle: {
            pl: "ul. Olszynowa Rabowice",
            en: "Olszynowa Street – Rabowice"
        },
        description: {
            pl: "",
            en: ""
        },
        imageCount: 1,
        video: false
    },

    "ul. Chałubińskiego Gdańsk": {
        title: {
            pl: "ul. Chałubińskiego Gdańsk",
            en: "Chałubińskiego Street – Gdańsk"
        },
        link: "ul-chalubinskiego-gdansk",
        descriptionTitle: {
            pl: "ul. Chałubińskiego Gdańsk",
            en: "Chałubińskiego Street – Gdańsk"
        },
        description: {
            pl: "",
            en: ""
        },
        imageCount: 1,
        video: false
    },

    "Renowacja i przebudowa kostki w Poznaniu": {
        title: {
            pl: "Renowacja i przebudowa kostki w Poznaniu",
            en: "Renovation and redevelopment of paving in Poznań"
        },
        link: "renowacja-i-przebudowa-kostki-w-poznaniu",
        descriptionTitle: {
            pl: "Renowacja i przebudowa kostki w Poznaniu",
            en: "Renovation and redevelopment of paving in Poznań"
        },
        description: {
            pl: "",
            en: ""
        },
        imageCount: 1,
        video: false
    },

    "Gdańsk Zaspa": {
        title: {
            pl: "Gdańsk Zaspa",
            en: "Gdańsk Zaspa"
        },
        link: "gdansk-zaspa",
        descriptionTitle: {
            pl: "Mieszkanie wykończone pod klucz – Gdańsk Zaspa",
            en: "Turnkey finished apartment – Gdańsk Zaspa"
        },
        description: {
            pl: `
      Realizacja wykończenia mieszkania deweloperskiego w inwestycji zlokalizowanej na <strong>gdańskiej Zaspie</strong>.
      <br><br>
      Projekt został zrealizowany w systemie "pod klucz" – od stanu surowego po finalne, w pełni wykończone wnętrze. 
      Skupiliśmy się na precyzyjnym wykonaniu, wysokiej estetyce oraz trwałości zastosowanych rozwiązań.
      <br><br>
      <strong>Zakres prac:</strong><br>
      – przygotowanie i wylewki<br>
      – wykonanie instalacji wodno-kanalizacyjnej oraz elektrycznej<br>
      – prace tynkarskie i gładzie<br>
      – pełne wykończenie łazienki: zabudowy, armatura, glazura<br>
      – montaż podłóg, drzwi oraz zabudów<br>
      – prace wykończeniowe i przygotowanie do umeblowania
    `,
            en: `
      Finishing of a developer apartment in an investment located in <strong>Gdańsk Zaspa</strong>.
      <br><br>
      The project was carried out in a turnkey system – from shell state to a fully finished interior. 
      We focused on precise execution, high aesthetics, and durability of the applied solutions.
      <br><br>
      <strong>Scope of work:</strong><br>
      – preparation and screeds<br>
      – installation of plumbing and electrical systems<br>
      – plastering and smoothing<br>
      – complete bathroom finishing: built-ins, fittings, tiling<br>
      – installation of floors, doors and custom furniture<br>
      – finishing works and furnishing preparation
    `
        },
        imageCount: 12,
        video: false
    },

    "Os. PrzyUnii": {
        title: {
            pl: "Os. PrzyUnii",
            en: "PrzyUnii Estate"
        },
        link: "os-przyunii",
        descriptionTitle: {
            pl: "Os. PrzyUnii",
            en: "PrzyUnii Estate"
        },
        description: {
            pl: "",
            en: ""
        },
        imageCount: 2,
        video: false
    },

    "Apartament ul. Podgórze": {
        title: {
            pl: "Apartament ul. Podgórze",
            en: "Apartment – Podgórze Street"
        },
        link: "apartament-ul-podgorze",
        descriptionTitle: {
            pl: "Apartament ul. Podgórze",
            en: "Apartment – Podgórze Street"
        },
        description: {
            pl: "",
            en: ""
        },
        imageCount: 7,
        video: false
    },

    "Ul. Łazienna w centrum Poznania": {
        title: {
            pl: "Ul. Łazienna w centrum Poznania",
            en: "Łazienna Street in the center of Poznań"
        },
        link: "ul-lazienna-w-centrum-poznania",
        descriptionTitle: {
            pl: "Ul. Łazienna w centrum Poznania",
            en: "Łazienna Street in the center of Poznań"
        },
        description: {
            pl: "",
            en: ""
        },
        imageCount: 11,
        video: false
    },

    "RobyG Piątkowo - ulica Wojciechowskiego 7": {
        title: {
            pl: "RobyG Piątkowo - ulica Wojciechowskiego 7",
            en: "RobyG Piątkowo – Wojciechowskiego Street 7"
        },
        link: "robyg-piatkowo-ulica-wojciechowskiego-7",
        descriptionTitle: {
            pl: "RobyG Piątkowo - ulica Wojciechowskiego 7",
            en: "RobyG Piątkowo – Wojciechowskiego Street 7"
        },
        description: {
            pl: "",
            en: ""
        },
        imageCount: 15,
        video: false
    },
};
